import React from "react";

function rrText() {
  return (
    <React.Fragment>
      <span className="fs-42 nexaBold ctext-primary m-b-20">Random</span>
      <span className="fs-42 nexaBold ctext-secondary">Ride</span>
    </React.Fragment>
  );
}

export default rrText;
